import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  PublicSubnet,
  PublicSubnetExtensionSchema,
  validatePublicSubnet,
  VPCAttachment,
  VPCAttachmentExtensionSchema,
} from './VpcAttachment';

export const AWSWorkloadVPCAttachmentFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AWSWorkload_VPCAttachmentField',
    component: VPCAttachment,
    schema: VPCAttachmentExtensionSchema,
  }),
);

export const AWSWorkloadPublicSubnetFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AWSWorkload_PublicSubnetField',
    component: PublicSubnet,
    validation: validatePublicSubnet,
    schema: PublicSubnetExtensionSchema,
  }),
);
